'use client';

import React, {useEffect, useState} from "react";
import clsx from "clsx";
import {getLocalStorage, setLocalStorage} from "./_lib/storageHelper";

declare global {
    interface Window {
        google:any;
        gtag:any;
    }
}

export default function CookieBanner(){
    const [analyticConsent, setAnalyticConsent] = useState(false);
    const [marketingConsent, setMarketingConsent] = useState(false);
    const [personalizationConsent, setPersonalizationConsent] = useState(false);
    const [show, setShow] = useState<boolean>();
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        const storedCookieConsentAnalytic = getLocalStorage("cookie_consent_analytic", null);
        const storedCookieConsentMarketing = getLocalStorage("cookie_consent_marketing", null);
        const storedCookieConsentPersonalization = getLocalStorage("cookie_consent_personalization", null);


        if (storedCookieConsentAnalytic == null) {
            setShow(true);
        } else {
            setAnalyticConsent(storedCookieConsentAnalytic);
            setMarketingConsent(storedCookieConsentMarketing);
            setPersonalizationConsent(storedCookieConsentPersonalization);
        }


    }, [setAnalyticConsent,setMarketingConsent,setPersonalizationConsent]);

    const saveHandler = () => {
        const analytic = analyticConsent ? "granted" : "denied";
        const marketing = marketingConsent ? "granted" : "denied";
        const personalization = personalizationConsent ? "granted" : "denied";

        const consent = {
            ad_storage: marketing,
            ad_user_data: marketing,
            ad_personalization: personalization,
            analytics_storage: analytic,
            personalization_storage: personalization,
            personalization: personalization,
            functionality_storage: personalization,
        }

        window.gtag("consent", "update", consent);

        setLocalStorage("cookie_consent_analytic", analyticConsent);
        setLocalStorage("cookie_consent_marketing", marketingConsent);
        setLocalStorage("cookie_consent_personalization", personalizationConsent);
        setLocalStorage("consentMode", consent);
        setShow(false);
    }

    useEffect(() => {

        if (!show || opened) {
            return;
        }

        saveHandler();

    }, [analyticConsent, marketingConsent, personalizationConsent]);

    const changeCheckboxHandler = (event : React.FormEvent<HTMLInputElement>) => {
        switch ((event.target as HTMLInputElement).id) {
            case 'analyticCheckbox': setAnalyticConsent((event.target as HTMLInputElement).checked); break;
            case 'marketingCheckbox': setMarketingConsent((event.target as HTMLInputElement).checked); break;
            case 'personalizationCheckbox': setPersonalizationConsent((event.target as HTMLInputElement).checked); break;
        }
    }

    const bannerStyle = clsx(
        ` transition-[opacity bottom] duration-500 ease-in-out my-3 lg:my-10 mx-auto  md:max-w-screen-sm fixed  left-0 right-0 px-3 md:px-7 py-3 z-[1000] 
        bg-sand border border-gray-200 rounded-lg shadow  max-w-[90vw] md:max-w-[600px] max-h-screen max-h-[90vh]`,
        {
           "opacity-100 bottom-0": show,
           "opacity-0 -bottom-[500px]": !show
        })


    return (
        <>
        <div className="inline-block text-xs uppercase hover:underline cursor-pointer" onClick={()=> {setOpened(true); setShow((prevState) => { return !prevState;}); } }>Sütikezelés</div>
        <div className={bannerStyle}>
            {
                opened ?
                    <div className="flex flex-col mb-2 md:mb-5 max-h-[calc(85vh-6.5rem)] overflow-auto px-2">
                        <div className="flex gap-10 border-b border-b-gray-100">
                            <div className=" py-2 px-1.5  pt-3">
                                <h6 className="font-bold text-lg tracking-tight bg-sand !text-black p-0">Funkcionális</h6>
                                <p className="text-xs">A weboldal működéséhez elengedhetetlen sütik, melyek személyes adatokat nem tartalmaznak.</p>
                            </div>
                            <div className="flex-shrink pt-3"><label className="inline-flex items-center cursor-pointer mt-1">
                                <input  type="checkbox" value="" checked={true} disabled={true} className="sr-only peer"/>
                                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-gray-900"></div>
                            </label></div>
                        </div>
                        <div className="flex gap-10 border-b border-b-gray-100">
                            <div className=" py-2 px-1.5  pt-3">
                                <h6 className="font-bold text-lg tracking-tight bg-sand !text-black p-0">Analitika</h6>
                                <p className="text-xs">Az elemzésekkel – például a látogatás időtartamának mérésével – kapcsolatos információk tárolása, melyet a Google-nek továbbítunk.</p>
                            </div>
                            <div className="flex-shrink pt-3"><label className="inline-flex items-center cursor-pointer mt-1">
                                <input id="analyticCheckbox" checked={analyticConsent}
                                       onChange={changeCheckboxHandler} type="checkbox" value=""  className="sr-only peer"/>
                                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-gray-900"></div>
                            </label></div>
                        </div>
                        <div className="flex gap-10 border-b border-b-gray-100">
                            <div className=" py-2 px-1.5  pt-3">
                                <h6 className="font-bold text-lg tracking-tight bg-sand !text-black p-0">Marketing</h6>
                                <p className="text-xs">A hirdetésekkel kapcsolatos információk, cookiek tárolása. A hirdetésekkel kapcsolatos felhasználói adatokat a Google-nek továbbítjuk.</p>
                            </div>
                            <div className="flex-shrink pt-3"><label className="inline-flex items-center cursor-pointer mt-1">
                                <input id="marketingCheckbox" checked={marketingConsent}
                                       onChange={changeCheckboxHandler} type="checkbox" value=""  className="sr-only peer"/>
                                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-gray-900"></div>
                            </label></div>
                        </div>
                        <div className="flex gap-10 border-b border-b-gray-100">
                            <div className=" py-2 px-1.5  pt-3">
                                <h6 className="font-bold text-lg tracking-tight bg-sand !text-black p-0">Személyreszabás</h6>
                                <p className="text-xs">Személyre szabott hirdetések és más pl. videóajánlásokkal kapcsolatos tárhely használatát.</p>
                            </div>
                            <div className="flex-shrink pt-3"><label className="inline-flex items-center cursor-pointer mt-1">
                                <input id="personalizationCheckbox" checked={personalizationConsent}
                                       onChange={changeCheckboxHandler} type="checkbox" value=""  className="sr-only peer"/>
                                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-gray-900"></div>
                            </label></div>
                        </div>
                    </div>
                    : null
            }

            <div className="flex justify-stretch items-center flex-col sm:flex-row gap-4">
                {
                    !opened ?
                        <div className=" flex-grow">
                            <p className="cursor-pointer hover:underline" onClick={() => setOpened(true)}>Weboldalunk <span className="font-bold text-sky-400">sütiket</span> használ.
                            </p>
                        </div> : <div className="flex-grow"></div>
                }

                <div className="flex gap-2 flex-row justify-end flex-shrink">
                    <button
                        className="px-3 py-1 text-sm md:text-base md:px-5 md:py-2 text-black rounded-md border-1 border-black"
                        onClick={() => {
                            if (!opened) {
                                saveHandler();
                                return;
                            }

                            setAnalyticConsent(false);
                            setMarketingConsent(false);
                            setPersonalizationConsent(false);

                        }}
                    >{opened ? 'Mindet elutasítom' : 'Elutasítom'}</button>
                    <button
                        className='bg-secondary px-5 py-2 text-white rounded-lg'
                        onClick={() => {
                            setAnalyticConsent(true);
                            setMarketingConsent(true);
                            setPersonalizationConsent(true);

                        }}
                    >{opened ? 'Mindet elfogadom' : 'Elfogadom'}</button>
                    {opened ?
                        <button
                        className='bg-primary px-5 py-2 text-white rounded-lg'
                        onClick={() =>  saveHandler()}
                    >Mentés</button> : null }
                </div>
            </div>
        </div>
        </>
    )
}
